<script>
  export let editing = false;
  export let error = false;
</script>

<div class="field" class:error class:editing>
  <slot />
</div>

<style lang="scss" src="./field.scss"></style>
